// Does a marketplace listing have any "additional" content to collapse behind the
// More details / Show less toggle? Additional content = description, a non-empty revenue
// breakdown, or (when the detailed-questions feature is on) any of the detail fields.
// Kept pure for unit testing.

const num = (v) => parseFloat(v) || 0;

export const listingHasRevenueBreakdown = (listing) => {
  if (!listing) return false;
  return num(listing.fee_based_revenue) + num(listing.trails_revenue)
    + num(listing.direct_revenue) + num(listing.commission_revenue) > 0;
};

export const hasAdditionalCardDetails = (listing, { detailedQuestions = false } = {}) => {
  if (!listing) return false;
  return Boolean(
    listing.description
    || listingHasRevenueBreakdown(listing)
    || (detailedQuestions && (
      listing.client_demographics_details
      || listing.services_provided_details
      || listing.other_details
    ))
  );
};
